export default __webpack_public_path__ + "static/media/mask_1.fc132634.png";